import React from 'react';
//import DropDownMenu from 'material-ui/DropDownMenu';
//import MenuItem from 'material-ui/MenuItem';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const Sort = ({ value, onChange }) => (
  <div className="sort">
    <div className="sort__text">Sort by:</div>
    <Select
      value={value}
      onChange={onChange}
      disableUnderline
      classes={{ root: 'dropDownMenu' }}
      MenuProps={{
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        getContentAnchorEl: null,
      }}
    >
      <MenuItem value={0}>first name</MenuItem>
      <MenuItem value={1}>last name</MenuItem>
      <MenuItem value={2}>date created</MenuItem>
      <MenuItem value={3}>status</MenuItem>
    </Select>
  </div>
);

export default Sort;
